/* product-form.js — current behavior + low-noise popup diagnostics + likely-Rebuy fallback
   Toggle logs: window.__CART_DEBUG__ = true/false (shared with cart-drawer.js)
*/
const PDBG = (...args) => { if (window.__CART_DEBUG__ ?? true) console.log(...args); };

/* ----- Small utilities (idempotent) ----- */
if (!window.replaceCartIconBubbleHTML) {
  window.replaceCartIconBubbleHTML = function replaceCartIconBubbleHTML(sectionHTML) {
    try {
      const target = document.querySelector('#cart-icon-bubble');
      if (!target || !sectionHTML) return;
      const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
      const src = doc.querySelector('#cart-icon-bubble');
      if (src) target.innerHTML = src.innerHTML;
      PDBG('[Cart Count] 🔁 replaceCartIconBubbleHTML (PF)');
    } catch (e) { console.warn('[Cart Count] replaceCartIconBubbleHTML failed:', e); }
  };
}
if (!window.refreshCartBadgeFromCart) {
  window.refreshCartBadgeFromCart = async function refreshCartBadgeFromCart() {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
      const count = cart.items.reduce((sum, item) => {
        const tags = item.product_tags || item.tags || [];
        const tagArr = Array.isArray(tags) ? tags : String(tags).split(',');
        const hasMonogram = tagArr.map(t => String(t).trim().toLowerCase()).includes('monogram fee');
        return hasMonogram ? sum : sum + (item.quantity || 0);
      }, 0);
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = String(count));
      document.querySelectorAll('[data-cart-count-ada]').forEach(el => el.textContent = `${count} item${count === 1 ? '' : 's'}`);
      document.querySelectorAll('[data-cart-counter-bubble]').forEach(el => el.classList.toggle('hidden', count <= 0));
      PDBG('[Cart Count] ✅ Updated from cart.js →', count, '(PF)');
    } catch (err) { console.warn('[Cart Count] ❌ Failed to update from cart.js:', err); }
  };
}

/* ----- Popup visibility helper (silent) + low-noise monitor ----- */
// Silent checker
function pfPopupIsVisible() {
  try {
    const sel = [
      '.rebuy-widget-popup', '.rebuy-modal', '.rebuy-modal-container', '.rebuy__modal',
      '[data-rebuy-widget-type="popup"]', '[class*="rebuy"][class*="modal"]', '[class*="rebuy"][class*="popup"]',
      '[role="dialog"][class*="rebuy"]'
    ].join(',');
    const nodes = Array.from(document.querySelectorAll(sel));
    return nodes.some(el => {
      const cs = getComputedStyle(el);
      return cs.display !== 'none' &&
             cs.visibility !== 'hidden' &&
             (el.offsetWidth * el.offsetHeight) > 0 &&
             el.getAttribute?.('aria-hidden') !== 'true';
    });
  } catch {
    return false;
  }
}
// Monitor logs ONLY on state changes; also tracks recency timestamp
(function monitorPopup() {
  let _last = null;
  window.__pfPopupLastSeen = window.__pfPopupLastSeen || 0;
  setInterval(() => {
    const vis = pfPopupIsVisible();
    if (vis !== _last) {
      if (window.__CART_DEBUG__ ?? true) console.log('[PF Popup] state →', vis ? 'visible' : 'hidden');
      _last = vis;
    }
    if (vis) window.__pfPopupLastSeen = Date.now();
  }, 500);
})();
function wasPopupJustVisible(ms = 3000) {
  return Date.now() - (window.__pfPopupLastSeen || 0) < ms;
}

/* Is there any Rebuy popup-capable widget on this page? (heuristic) */
function hasRebuyPopupWidget() {
  try {
    const sel = [
      '[data-rebuy-widget-type="popup"]',
      '.rebuy-widget-popup',
      '.rebuy-modal',
      '.rebuy-modal-container',
      '.rebuy__modal',
      '[class*="rebuy"][class*="modal"]',
      '[class*="rebuy"][class*="popup"]',
      '[role="dialog"][class*="rebuy"]',
      '[data-rebuy-id]',
      '[data-rebuy-widget]',
      '[data-rebuy]' // some themes mark containers this way
    ].join(',');
    return !!document.querySelector(sel);
  } catch { return false; }
}

/* ----- Log Rebuy events to correlate flows ----- */
['rebuy:cart.change', 'rebuy:cart.add', 'rebuy.add'].forEach(ev => {
  document.addEventListener(ev, (e) => {
    PDBG('[Rebuy EVT]', ev, 'detail=', e?.detail);
  });
});

/* ----- Open drawer after Rebuy popup add (behavior unchanged, logs added) ----- */
(function installPopupAddOpen() {
  if (window.__rebuyPopupAddOpenInstalled) return;
  window.__rebuyPopupAddOpenInstalled = true;

  async function openAfterPopupAdd() {
    const nowVis = pfPopupIsVisible();
    const recently = wasPopupJustVisible();
    PDBG('[PF PopupAdd] fired — visible?', nowVis, 'recent?', recently);
    if (!nowVis && !recently) return;

    // best-effort close
    document.querySelector('.rebuy-modal-close,[aria-label="close modal"]')?.click();

    const t0 = Date.now();
    while (pfPopupIsVisible() && Date.now() - t0 < 1200) {
      await new Promise(r => setTimeout(r, 50));
    }

    // clear expected window; allow open
    PDBG('[PF PopupAdd] clearing expected window and marking drawer stale');
    window.__rebuyPopupExpectedUntil = 0;
    window.dispatchEvent(new Event('cart-drawer:stale'));

    try {
      const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const sections = await res.json();
      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer?.renderContents) {
        PDBG('[PF PopupAdd] renderContents(autoOpen:false) then open()');
        cartDrawer.renderContents(
          { id: Date.now(), sections: { 'cart-drawer': sections['cart-drawer'], 'cart-icon-bubble': sections['cart-icon-bubble'] } },
          { autoOpen: false }
        );
        replaceCartIconBubbleHTML(sections['cart-icon-bubble']);
        queueMicrotask(() => refreshCartBadgeFromCart());
        setTimeout(() => cartDrawer.open?.(), 80);
      } else {
        PDBG('[PF PopupAdd] fallback direct open()');
        document.querySelector('cart-drawer')?.open?.();
      }

      window.RebuyHydrator?.markRender('popup-add');
    } catch (e) { console.warn('[Rebuy popup add] failed to refresh/open drawer:', e); }
  }

  // document.addEventListener('rebuy:cart.change', openAfterPopupAdd);
  document.addEventListener('rebuy:cart.add', openAfterPopupAdd);
  document.addEventListener('rebuy.add', openAfterPopupAdd);
  document.addEventListener('rebuy.hide', () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && !cartDrawer.classList.contains('active')) {
      cartDrawer.open?.();
    }
  });

  // Mark drawer stale on ANY Rebuy cart change (diagnostic)
  document.addEventListener('rebuy:cart.change', () => {
    PDBG('[PF] marking drawer stale (rebuy:cart.change)');
    window.dispatchEvent(new Event('cart-drawer:stale'));
  });
})();

/* ----- Product Form ----- */
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.cleanupFuncs = [];

        this.lastWindowWidth = window.innerWidth;
        this.stickyObserver = null;

        this.selectedAddons = [];
        this.form = this.querySelector('form');
        if (this.form?.querySelector('[name=id]')) this.form.querySelector('[name=id]').disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';

        this.setSelectedAddons = this.setSelectedAddons.bind(this);
        this.handleVariantChanged = this.handleVariantChanged.bind(this);
        this.initStickyObserver = this.initStickyObserver.bind(this);
        this.resizeHandler = this.resizeHandler.bind(this);
        this.onSubmitHandler = this.onSubmitHandler.bind(this);

        document.addEventListener('variant:changed', this.handleVariantChanged);
        this.cleanupFuncs.push(() => document.removeEventListener('variant:changed', this.handleVariantChanged));

        const pdpAddonsSelectedUnsubscriber = subscribe('pdp-addons:selected', this.setSelectedAddons);
        this.cleanupFuncs.push(() => pdpAddonsSelectedUnsubscriber());

        this.form?.addEventListener('submit', this.onSubmitHandler);
        this.cleanupFuncs.push(() => this.form?.removeEventListener('submit', this.onSubmitHandler));

        this.stickyObserve()
      }

      disconnectedCallback() {
        this.cleanupFuncs.forEach((func) => {
          func.call(this)
        })
      }

      resizeHandler() {
        if (window.innerWidth === this.lastWindowWidth) return;

        this.lastWindowWidth = window.innerWidth;

        this.initStickyObserver();
      }

      handleVariantChanged(e) {
        const options = e.detail.options;
        const optionNames = e.detail.optionNames;

        this.updateSelectedOptionSticky(options, optionNames);
      }

      updateSelectedOptionSticky(options, optionNames) {
        if (!options.length || !optionNames.length) return;

        const selectedOptionsStickyEl = this.querySelector('[data-selected-options-sticky]');

        if (!options.length) return;

        const modifySizeNames = ['Leash Size', 'Collar Size', 'Harness Size', 'Robe Size', 'PJ Size', 'Dog Bandana Size', 'Bandana Size'];
        const selectedOptions = options.length === 1
          ? options
          : optionNames.map((optionName, index) => {
            const shouldBeModified = modifySizeNames.includes(optionName);
            const modifiedName = shouldBeModified ? optionName.replace('Size', '').trim() : optionName
            const modifiedValue = shouldBeModified ? options[index].split('-').reverse().pop().trim() : options[index];
            return `${modifiedName} (${modifiedValue})`;
          });

        const includedProducts = (this.getAttribute('data-included-products') || '').split('|').filter(Boolean);

        if (includedProducts.length) {
          selectedOptions.push(...includedProducts);
        }

        if (selectedOptionsStickyEl && selectedOptions.length) {
          selectedOptionsStickyEl.innerHTML = selectedOptions.join(' + ');
        }
      }

      initStickyObserver() {
        const pivotEl = this.querySelector('.js-product-form-sticky-pivot');
        const isSticky = this.hasAttribute('data-sticky-enabled');

        if (!pivotEl) return;

        if (this.stickyObserver) this.stickyObserver.disconnect();

        const stickyHeaderEl = document.querySelector('sticky-header')
        const headerHeight = stickyHeaderEl ? Math.ceil(stickyHeaderEl.getBoundingClientRect().height) : 0;

        const observerConfig = {
          callback: (entries) => {
            entries.forEach(entry => {
              const height = Math.ceil(this.getBoundingClientRect().height);
              if (!entry.isIntersecting) {
                this.style.setProperty('--product-form-height', `${height}px`);
                this.classList.add('sticky-activated');
              } else {
                this.style.removeProperty('--product-form-height');
                this.classList.remove('sticky-activated');
              }
            })
          },
          options: {
            root: null,
            rootMargin: `${-headerHeight}px 0px 0px`,
            threshold: 0
          }
        };
        const observer = new IntersectionObserver(observerConfig.callback, observerConfig.options);
        observer.observe(pivotEl);

        this.stickyObserver = observer;
        this.cleanupFuncs.push(() => observer.disconnect())
      }

      stickyObserve() {
        this.initStickyObserver();

        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', this.initStickyObserver);
          this.cleanupFuncs.push(() => window.visualViewport.removeEventListener('resize', this.initStickyObserver));
        } else {
          window.addEventListener('resize', this.resizeHandler);
          this.cleanupFuncs.push(() => window.removeEventListener('resize', this.resizeHandler));
        }
      }

      setSubmitButtonState(isLoading) {
        if (isLoading) {
          this.submitButton.disabled = true;
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner')?.classList.remove('hidden');
        } else {
          this.submitButton.disabled = false;
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      }

      setSelectedAddons({ selectedAddons }) {
        this.selectedAddons = selectedAddons

        const crossSellAddonsStickyEl = this.querySelector('[data-selected-cross-sell-addons-sticky]');

        if (crossSellAddonsStickyEl) {
          crossSellAddonsStickyEl.innerHTML = this.selectedAddons.length ? `+${this.selectedAddons.length} Add-ons` : '';
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        PDBG('[PF] onSubmit start; initial data-rebuy=', this.dataset.rebuy);

        if (this.submitButton?.disabled) return;

        this.setSubmitButtonState(true);

        const rebuyReady = await this.ensureRebuyTagReady();
        PDBG('[PF] ensureRebuyTagReady →', rebuyReady, 'final data-rebuy=', this.dataset.rebuy);

        const isRebuyProduct = this.dataset.rebuy === 'true';
        const isLikelyRebuy = isRebuyProduct || hasRebuyPopupWidget();
        PDBG('[PF] isRebuyProduct=', isRebuyProduct, 'isLikelyRebuy=', isLikelyRebuy);

        if (isLikelyRebuy) {
          window.__rebuyPopupExpectedUntil = Date.now() + 5000;
          PDBG('[PF] set expectedUntil (likely Rebuy) →', window.__rebuyPopupExpectedUntil);
        }

        this.handleErrorMessage();

        const config = fetchConfig('javascript');
        // config.headers['X-Requested-With'] = 'XMLHttpRequest';
        // delete config.headers['Content-Type'];

        const body = {
          items: []
        };
        const defaultItemKeys = ['id', 'quantity'];

        const formData = new FormData(this.form);
        const mainItem = {};

        if (this.cart) {
          const ids = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections = ids.join(',');
          // formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement?.(document.activeElement);
        }

        formData.forEach((value, key) => {
          if (defaultItemKeys.includes(key)) {
            mainItem[key] = value;
            return;
          }

          if (key.startsWith('properties[') && key.endsWith(']')) {
            const propertyKey = key.slice(11, -1);
            mainItem.properties = mainItem.properties || {};
            mainItem.properties[propertyKey] = value;
            return;
          }

          if (key !== 'sections' && key !== 'sections_url') {
            mainItem[key] = value;
          }
        });

        if (this.selectedAddons.length) {
          const uniqueAddonId = crypto.randomUUID();

          mainItem.properties = mainItem.properties || {};
          mainItem.properties['_has_addons'] = 'Yes';
          mainItem.properties['_addons_key'] = uniqueAddonId;

          this.selectedAddons.forEach(addon => {
            const addonItems = addon.items.map(addonItem => {
              const addonProperties = addonItem.properties || {};

              if (addonItem.id === addon.variantId) {
                addonProperties['_is_addon'] = 'Yes';
                addonProperties['_addon_key'] = uniqueAddonId;
              }

              return {
                ...addonItem,
                properties: addonProperties
              }
            });

            body.items = body.items.concat(addonItems);
          });
        }

        body.items.push(mainItem);

        config.body = JSON.stringify(body);

        publish(PUB_SUB_EVENTS.cartLoading, { source: 'cart-items' });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            PDBG('[PF] cart_add response.status=', response.status, 'message=', response.message);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'),
                errors: response.errors || response.description, message: response.message });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton?.setAttribute('aria-disabled', true);
              this.submitButton?.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.cart) { window.location = window.routes.cart_url; return; }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
              queueMicrotask(() => refreshCartBadgeFromCart());
            }
            this.error = false;

            // Use likely-Rebuy for deciding auto-open
            const shouldAutoOpen = !isLikelyRebuy;
            PDBG('[PF] renderCartSections → shouldAutoOpen=', shouldAutoOpen, '(isLikelyRebuy=', isLikelyRebuy, ')');

            const renderCartSections = () => {
              fetch('/?sections=cart-drawer,cart-icon-bubble')
                .then((res) => res.json())
                .then((sections) => {
                  PDBG('[PF] injecting sections (cart-drawer, cart-icon-bubble)');
                  this.cart.renderContents(
                    { id: Date.now(), sections: { 'cart-drawer': sections['cart-drawer'], 'cart-icon-bubble': sections['cart-icon-bubble'] } },
                    { autoOpen: shouldAutoOpen }
                  );
                  replaceCartIconBubbleHTML(sections['cart-icon-bubble']);
                  queueMicrotask(() => refreshCartBadgeFromCart());

                  // Fallback: if we expected a popup but none appears quickly, open the drawer
                  if (!shouldAutoOpen) {
                    setTimeout(() => {
                      const popupNow = pfPopupIsVisible();
                      const recently = wasPopupJustVisible(1200);
                      PDBG('[PF] fallback check → popupNow=', popupNow, 'recently=', recently);
                      if (!popupNow && !recently) {
                        PDBG('[PF] no popup appeared; opening drawer (fallback)');
                        try { this.cart.open?.(); } catch {}
                      } else {
                        PDBG('[PF] popup visible/recent — no fallback open');
                      }
                    }, 450);
                  }

                  window.RebuyHydrator?.markRender(shouldAutoOpen ? 'non-rebuy-open' : 'pdp-rebuy-render');
                })
                .catch((e) => console.warn('[ProductForm] Failed to render cart sections:', e));
            };

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => setTimeout(renderCartSections, 0), { once: true });
              quickAddModal.hide?.(true);
            } else {
              renderCartSections();
            }

            const variantId = parseInt(formData.get('id'), 10);
            const productId = this.dataset.productId ? parseInt(this.dataset.productId, 10) : undefined;
            if (isRebuyProduct && window.Rebuy?.Engine?.fire && variantId) {
              try {
                PDBG('[PF] Rebuy Engine.fire("add to cart") productId=', productId, 'variantId=', variantId);
                window.Rebuy.Engine.fire('add to cart', { product_id: productId, variant_id: variantId, quantity: 1 });
              } catch (e) { console.warn('[ProductForm] Rebuy Engine.fire failed:', e); }
            }

            setTimeout(() => {
              const vis = pfPopupIsVisible();
              if (!vis) {
                window.__rebuyPopupExpectedUntil = 0;
                PDBG('[PF] no popup visible after delay → clear expectedUntil');
              } else {
                PDBG('[PF] popup still visible after delay (expected for Rebuy PDP flow)');
              }
            }, 3000);
          })
          .catch((e) => { console.error('[ProductForm] Add to cart failed:', e); })
          .finally(() => {
            if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            publish(PUB_SUB_EVENTS.cartUnloading, { source: 'cart-items' });

            setTimeout(() => {
              this.setSubmitButtonState(false);
            }, 500);
          });
      }

      async ensureRebuyTagReady() {
        const isRebuy = () => this.dataset.rebuy === 'true';
        if (isRebuy()) return true;

        return new Promise((resolve) => {
          let attempts = 0;
          const maxAttempts = 40; // ~2s @ 50ms
          const check = () => {
            if (isRebuy()) { PDBG('[PF] data-rebuy became true after', attempts, 'polls'); resolve(true); }
            else if (++attempts > maxAttempts) { PDBG('[PF] data-rebuy never became true (2s timeout)'); resolve(false); }
            else setTimeout(check, 50);
          };
          check();
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }
    }
  );
}
